// SearchBarMobile.js
import { defineComponent, ref, computed, watch } from '/Scripts/vue.esm-browser.js';

export default defineComponent({
    name: 'SearchBarMobile',
    props: {
    },
    emits: [],
    setup(props, { emit }) {
        return {
        };
    },
    template: `
    <div class="searchbar_m">
        <div class="searchbar_input"><span>搜尋</span></div>
    </div>
  `,
    methods: {
    },
});
